import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-speedtest-answer',
  templateUrl: './speedtest-answer.component.html',
  styleUrls: ['./speedtest-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SpeedtestAnswerComponent {
}
